export const buildCrudQueryParams = ({
  page,
  size,
  filters = {},
  sortConfig = {},
  companyId = null,
  sortMode = 'split',
}) => {
  const queryParams = new URLSearchParams();

  if (page !== undefined && page !== null) {
    queryParams.append('page', String(page));
  }
  if (size !== undefined && size !== null) {
    queryParams.append('size', String(size));
  }

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const filterParamKey = `filters[${key}]`;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === undefined || item === null) return;
        const asString = String(item).trim();
        if (asString === '') return;
        queryParams.append(filterParamKey, asString);
      });
      return;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '') return;
      queryParams.append(filterParamKey, trimmed);
      return;
    }

    queryParams.append(filterParamKey, String(value));
  });

  if (companyId !== undefined && companyId !== null && String(companyId).trim() !== '') {
    queryParams.set('filters[companyId]', String(companyId));
  }

  const rawSortKey = String(sortConfig?.key ?? sortConfig?.sortBy ?? '').trim();
  const rawSortDirection = String(sortConfig?.direction ?? sortConfig?.sortDirection ?? '').trim().toLowerCase();
  const [keyFromSort = '', dirFromSort = ''] = rawSortKey.split(',');
  const sortBy =
    keyFromSort && keyFromSort.toUpperCase() !== 'UNSORTED'
      ? keyFromSort.trim()
      : '';

  const dirToken = (dirFromSort || rawSortDirection).trim().toLowerCase();
  const sortDirection = dirToken === 'asc' || dirToken === 'ascending'
    ? 'asc'
    : dirToken === 'desc' || dirToken === 'descending'
      ? 'desc'
      : '';

  if (sortBy) {
    queryParams.set('sort', sortBy);
  }
  if (sortDirection) {
    queryParams.set('direction', sortDirection);
  }

  return queryParams;
};
